<template>
    <div>
        <EspSnackbar v-model="snackbarShow" :color="snackbarColor" :text="snackbarText" :timeout="6000"/>
    <v-card flat>
        <v-card-title primary-title class="justify-center">
            <img :src="`${this.customBasePath}/logo.png`" style="max-width:100%;max-height:60px"/>
        </v-card-title>
        <v-card-subtitle class="text-center pb-0">
            <div class="pt-6 headline font-weight-light">{{$t('menuLogin')}}</div>
        </v-card-subtitle>
        <v-card-text>
            <v-container>
                <v-form ref="form" v-model="valid">
                    <v-row v-if="!disableLogin" class="px-3" >
                        <v-col cols="12" >
                            <v-text-field
                                outlined
                                v-model="email"
                                :disabled="app_loading"
                                hide-details
                                required
                                :label="$t('loginEmail')"
                                @keydown.enter="loginUser"
                                placeholder="">
                            </v-text-field> <!-- :rules="emailRules" -->
                        </v-col>
                        <v-col cols="12" >
                            <v-text-field
                                outlined
                                :disabled="app_loading"
                                hide-details
                                v-model="password"
                                :label="$t('password')"
                                :rules="passwordRules"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                @keydown.enter="loginUser"
                            ></v-text-field>
                        </v-col>


                        <!-- Passwort Reset -->
                        <v-col v-if="!disablePasswordReset" cols="12" align="end" class="pt-0">
                            <v-btn text class="pl-1 caption text-transform-none underline font-weight-medium" @click="$emit('showPasswordReset')">{{$t('forgotPwRequest')}}</v-btn>
                        </v-col>
                    </v-row>

                    <!-- Login button -->
                    <v-row justify="center" no-gutters>
                        <v-col cols="12" align="center" class="pa-2">
                            <v-btn v-if="!disableLogin" class="" :color="theme.buttonGreen" large block depressed :loading="app_loading" rounded dark @click="loginUser" >{{$t('loginBtn')}}</v-btn>
                            <div v-if="login_error" class="red--text" v-html="$t('errorCodeInvalidCredentials')"></div>
                        </v-col>
                    </v-row>

                    <!-- Registration button -->
                    <v-row justify="center" no-gutters class="mb-2">
                        <v-col cols="12" align="center" class="pa-2">
                            <v-btn v-if="!disableRegisterPager" class="" color="grey lighten-1" large block depressed rounded dark @click="$emit('change')">
                                {{$t('registerBtn')}}
                            </v-btn>
                        </v-col>
                    </v-row>

                    <!-- Guest access sheet -->
                    <v-row v-if="!disableGuestAccess" justify="center" no-gutters>
                        <v-col cols="12" align="center" class="pa-2">
                            <v-btn v-if="disableLogin" class="" :color="theme.buttonGreen" large block depressed :loading="app_loading" rounded dark @click="$emit('doGuestAccessLogin')" >{{$t('loginBtn')}}</v-btn>
                            <v-btn v-else text class="pl-1 caption text-transform-none underline font-weight-medium" :loading="app_loading" @click="$emit('doGuestAccessLogin')">{{$t('loginWithoutRegistration')}}</v-btn>
                        </v-col>
                    </v-row>

                    <hr v-if="codeAccessEnabled">
                    <p v-if="codeAccessEnabled">{{$t('loginWith')}}</p>
                    <v-row v-if="codeAccessEnabled">
                        <!-- PIN Login -->
                        <v-col v-if="!disablePINAccess">
                            <EspButtonPinCheckin
                                :spot="null"
                                @success="onPinCodeEntered"
                                :disabled="false"
                            />
                        </v-col>
                        <!-- QR Login -->
                        <v-col v-if="!disableQRAccess">
                            <EspButtonQrCheckin
                                :spot="null"
                                @success="onQrCodeScanned"
                                icon="mdi-qrcode"
                                :label="$t('qrCode')"
                                :fctIsValidCode="isScannedCodeValid"
                                :disabled="false"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
    </div>
</template>

<script>
import CONFIG from "../../constants/config";
import {layoutMixin} from "../../utils/layout-mixin";
import {settingsMixin} from "../../utils/settings-mixin";
import {validationMixin} from "../../utils/validation-mixin";
import {qrLoginMixin} from "../../utils/qrlogin-mixin";
import {qrJoinMixin} from "../../utils/qr-join-mixin";
import EspButtonQrCheckin from "../spots/EspButtonQrCheckin";
import EspButtonPinCheckin from "./EspButtonPinCheckin.vue";
import EspSnackbar from "../ui/EspSnackbar.vue";
import sha1 from 'js-sha1'

export default {
    mixins:[settingsMixin,validationMixin,layoutMixin,qrLoginMixin,qrJoinMixin],
    components:{
        EspButtonQrCheckin,
        EspButtonPinCheckin,
        EspSnackbar
    },
    props:{
    },
    data: () => ({
        email:'',
        password:'',
        showPassword: false,
        login_error: false,
        valid: true,
        snackbarShow: false,
        snackbarText: '',
        snackbarColor: 'error'
    }),
    computed:{
        loginData(){
            return {
                email:this.email,
                password:sha1(this.password+this.email)
            }
        },
        loginQRData() {
            return {
                qr:this.getQrData()
            }
        },
        disableLogin() {
            return this.parseBoolean(CONFIG.DISABLE_LOGIN, false)
        },
        disableRegisterPager() {
            return this.parseBoolean(CONFIG.DISABLE_REGISTER, false)
        },
        disableGuestAccess() {
            return this.parseBoolean(CONFIG.DISABLE_GUEST_ACCESS, false)
        },
        disableQRAccess() {
            return this.parseBoolean(CONFIG.DISABLE_QR_ACCESS, false)
        },
        disablePINAccess() {
            return this.parseBoolean(CONFIG.DISABLE_PIN_ACCESS, false)
        },
        disablePasswordReset() {
            return this.parseBoolean(CONFIG.DISABLE_PASSWORT_RESET,false);
        },
        enabledGuestOrReg() {
            return !this.disableGuestAccess || !this.disableRegisterPager
        },
        codeAccessEnabled() {
            return !this.disablePINAccess || !this.disableQRAccess
        },
        onlyGuestAccessEnabled() {
            return this.disableLogin && this.disableQRAccess && !this.disableGuestAccess
        },
    },
    watch: {
        onlyGuestAccessEnabled: {
            handler(newVal) {
                if (newVal) {
                    this.$emit('doGuestAccessLogin');
                }
            },
            immediate: true
        }
    },
    methods:{

        validate () {
            this.$refs.form.validate()
        },

        loginUser(){
            if(!this.valid){
                this.validate();
                return;
            }

            this.login_error=false;
            this.login(this.loginData).then(()=>{
                this.$emit('next');
            }).catch(() => {
                console.log('Login error');
                this.login_error=true;
            });
        },

        loginUserWithQR() {
            this.loginWithQR(this.loginQRData).then(()=>{
                this.$emit('next');
            }).catch(() => {
                console.log('Login error');
                this.login_error=true;
            });
        },
        onQrCodeScanned(qrData){
            this.pinDataReceived(qrData);
        },
        onPinCodeEntered(qrData){
            this.pinDataReceived(qrData);
        },
        pinDataReceived(qrData) {
            const errorKey = this.handleScannedQr(qrData);
            if (errorKey) {
                this.showSnackbarError(this.$t(errorKey));
            }
        },
        showSnackbarError(message) {
            this.snackbarText = message;
            this.snackbarColor = 'error';
            this.snackbarShow = true;
        },
        onPageCreated(){
            if (this.hasQRData()) {
                if (this.isAutoLogin()) {
                    this.loginUserWithQR()
                }
            }
        }
    },
    created() {
        this.onPageCreated();
    }
}
</script>